import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { postMaintenanceWarning } from '../../../../actions/mechanical-maintenance';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import MaintenanceWarningForm from './MaintenanceWarningForm';
import { MAINTENANCE_WARNING_PATH } from '../../../../config/paths';
import {
  MAINTENANCE_ACTIVITY_TYPE,
  MAINTENANCE_WARNING_STATUS,
} from '../../../../config/constants';
import { tzNormalizeDate } from '../../../../utils/date';

const NewMaintenanceWarning = ({
  breadcrumbs,
  dispatchPostMaintenanceWarning,
}) => {
  const onSubmit = (formValues) =>
    dispatchPostMaintenanceWarning({
      reporterCustomerId: formValues.reporterCustomerId
        ? formValues.reporterCustomerId.value
        : null,

      issueDate: formValues.issueDate
        ? tzNormalizeDate({ date: formValues.issueDate })
        : null,

      registeredBusId: formValues.registeredBusId
        ? formValues.registeredBusId.value
        : null,

      actualVirtualOdometer:
        formValues.actualVirtualOdometer !== undefined
          ? formValues.actualVirtualOdometer
          : null,

      actualRegisteredBusOdometer:
        formValues.actualRegisteredBusOdometer !== undefined
          ? formValues.actualRegisteredBusOdometer
          : null,

      maintenanceWarningType: formValues.maintenanceWarningType
        ? formValues.maintenanceWarningType.value
        : null,

      maintenanceFailModeId: formValues.maintenanceFailModeId
        ? formValues.maintenanceFailModeId.value
        : null,

      maintenanceFailModeCategoryId: formValues.maintenanceFailModeCategoryId
        ? formValues.maintenanceFailModeCategoryId.value
        : null,

      activityId: formValues.activityId ? formValues.activityId.value : null,

      categoryId: formValues.maintenanceFailModeId
        ? formValues.maintenanceFailModeId.categoryId
        : null,

      subCategoryId: formValues.maintenanceFailModeId
        ? formValues.maintenanceFailModeId.subCategoryId
        : null,

      priority: formValues.priority ? formValues.priority.value : null,

      recurrence: formValues.recurrence ? formValues.recurrence.value : null,

      comments: formValues.comments !== undefined ? formValues.comments : null,

      status: MAINTENANCE_WARNING_STATUS.OPEN.value,
      creationType: MAINTENANCE_ACTIVITY_TYPE.CORRECTIVE.value,
    });

  const content = (
    <MaintenanceWarningForm
      onSubmit={onSubmit}
      initialValues={{
        issueDate: tzNormalizeDate().slice(0, 16),
        status: MAINTENANCE_WARNING_STATUS.OPEN,
      }}
    />
  );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nuevo Reporte de Ocurrencia"
      subtitle="Crear reporte de ocurrencia"
      content={content}
    />
  );
};

NewMaintenanceWarning.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostMaintenanceWarning: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostMaintenanceWarning: postMaintenanceWarning,
};

const mapStateToProps = ({ MechanicalMaintenanceUnit }) => ({
  breadcrumbs: [
    ...MechanicalMaintenanceUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Reportes de Ocurrencia',
      href: MAINTENANCE_WARNING_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewMaintenanceWarning);
